/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ToggleGoogleSSOInput = {|
  enableGoogleSSO?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ToggleGoogleSSOMutationVariables = {|
  input: ToggleGoogleSSOInput
|};
export type ToggleGoogleSSOMutationResponse = {|
  +toggleGoogleSSO: ?{|
    +company: ?{|
      +googleSSOEnabled: ?boolean
    |}
  |}
|};
export type ToggleGoogleSSOMutation = {|
  variables: ToggleGoogleSSOMutationVariables,
  response: ToggleGoogleSSOMutationResponse,
|};
*/


/*
mutation ToggleGoogleSSOMutation(
  $input: ToggleGoogleSSOInput!
) {
  toggleGoogleSSO(input: $input) {
    company {
      googleSSOEnabled
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ToggleGoogleSSOInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleSSOEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleGoogleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleGoogleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleGoogleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleGoogleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleGoogleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleGoogleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ToggleGoogleSSOMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleGoogleSSOMutation(\n  $input: ToggleGoogleSSOInput!\n) {\n  toggleGoogleSSO(input: $input) {\n    company {\n      googleSSOEnabled\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1ea888dc4fab1dbb6f2cc143d0ca6294';

module.exports = node;
